module.exports = __webpack_public_path__ + "static/media/Residential_40.72342796.jpg";